import { Observable, Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { Injectable } from '@angular/core';

@Injectable()
export class Bus {
  private subject: Subject<any> = new Subject<any>();

  publish<T>(token: string, data: T = null) {
    this.subject.next({
      token: token,
      data: data
    });
  }

  on<T>(token: string): Observable<T> {
    return this.subject.pipe(
      filter((x:any) => x.token === token),
      // Uncomment the next row to log all bus events
      // .do(x => console.log(`Token: ${x.token}, data: `, x.data))
      map((x:any) => <T>x.data), );
  }
}
